<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M2.73438 7.03125C2.73438 6.38404 3.25904 5.85938 3.90625 5.85938C4.55346 5.85938 5.07812 6.38404 5.07812 7.03125C5.07812 7.67846 4.55346 8.20312 3.90625 8.20312C3.25904 8.20312 2.73438 7.67846 2.73438 7.03125ZM7.8125 7.03125C7.8125 6.59978 8.16228 6.25 8.59375 6.25H21.0938C21.5252 6.25 21.875 6.59978 21.875 7.03125C21.875 7.46272 21.5252 7.8125 21.0938 7.8125H8.59375C8.16228 7.8125 7.8125 7.46272 7.8125 7.03125ZM2.73438 12.5C2.73438 11.8528 3.25904 11.3281 3.90625 11.3281C4.55346 11.3281 5.07812 11.8528 5.07812 12.5C5.07812 13.1472 4.55346 13.6719 3.90625 13.6719C3.25904 13.6719 2.73438 13.1472 2.73438 12.5ZM7.8125 12.5C7.8125 12.0685 8.16228 11.7188 8.59375 11.7188H21.0938C21.5252 11.7188 21.875 12.0685 21.875 12.5C21.875 12.9315 21.5252 13.2812 21.0938 13.2812H8.59375C8.16228 13.2812 7.8125 12.9315 7.8125 12.5ZM2.73438 17.9688C2.73438 17.3215 3.25904 16.7969 3.90625 16.7969C4.55346 16.7969 5.07812 17.3215 5.07812 17.9688C5.07812 18.616 4.55346 19.1406 3.90625 19.1406C3.25904 19.1406 2.73438 18.616 2.73438 17.9688ZM7.8125 17.9688C7.8125 17.5373 8.16228 17.1875 8.59375 17.1875H21.0938C21.5252 17.1875 21.875 17.5373 21.875 17.9688C21.875 18.4002 21.5252 18.75 21.0938 18.75H8.59375C8.16228 18.75 7.8125 18.4002 7.8125 17.9688Z"
				:fill="color"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgList',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
